export default "__VITE_ASSET__BHWsChla__"